import { passwordBindHandlers } from './password.js';
export function mainpassword() {
  setTimeout(() => {
    console.log('password');
    passwordBindHandlers();
  }, 100);
}
